import React from "react"
import "./LongestGapCards.scss"
import PropTypes from "prop-types"
import OverviewCard from "../OverviewCard"
import Loading from "../Loading"
import { secondsToHoursAndMinutes } from "../../helpers/sharedHelperFunctions"
import { Col } from "reactstrap"

const MISSING_DATA_MSG = "No data found. Try a new search or date range."

const LongestGap = props => {
  const longestGapArr = props.data[0]
  const longestDurationArr = props.data[1]

  const findMinGapOrDuration = dataArr => {
    if (dataArr.length) return secondsToHoursAndMinutes(Math.min(...dataArr))
    return MISSING_DATA_MSG
  }

  const findMaxGapOrDuration = dataArr => {
    if (dataArr.length) return secondsToHoursAndMinutes(Math.max(...dataArr))
    return MISSING_DATA_MSG
  }

  const findAverage = dataArr => {
    if (dataArr.length)
      return secondsToHoursAndMinutes(
        dataArr.reduce((a, b) => a + b) / dataArr.length
      )
    return MISSING_DATA_MSG
  }

  let textClass = ""
  if (longestDurationArr.length === 0 || longestGapArr.length === 0) {
    textClass = "content text-medium semi-bold"
  } else {
    textClass = "content heading-2 semi-bold"
  }

  return (
    <div className="LongestGapContainer">
      <Col lg="4" className={"d-inline-block"}>
        <OverviewCard>
          {props.loading ? (
            <Loading />
          ) : (
            <div className="card-container">
              <p className="card-title text-grey text-small">
                {props.bsrCompliance ? "Maximum Duration" : "Maximum Absence"}
              </p>
              <p className={textClass}>
                {props.bsrCompliance
                  ? `${findMaxGapOrDuration(longestDurationArr)}`
                  : `${findMaxGapOrDuration(longestGapArr)}`}
              </p>
              <div className="footer" />
            </div>
          )}
        </OverviewCard>
      </Col>
      <Col lg="4" className={"d-inline-block"}>
        <OverviewCard>
          {props.loading ? (
            <Loading />
          ) : (
            <div className="card-container">
              <p className="card-title text-grey text-small">
                {props.bsrCompliance ? "Average Duration" : "Average Absence"}
              </p>
              <p className={textClass}>
                {props.bsrCompliance
                  ? `${findAverage(longestDurationArr)}`
                  : `${findAverage(longestGapArr)}`}
              </p>
              <div className="footer" />
            </div>
          )}
        </OverviewCard>
      </Col>
      <Col lg="4" className={"d-inline-block"}>
        <OverviewCard>
          {props.loading ? (
            <Loading />
          ) : (
            <div className="card-container">
              <p className="card-title text-grey text-small">
                {props.bsrCompliance ? "Minimum Duration" : "Minimum Absence"}
              </p>
              <p className={textClass}>
                {props.bsrCompliance
                  ? `${findMinGapOrDuration(longestDurationArr)}`
                  : `${findMinGapOrDuration(longestGapArr)}`}
              </p>
              <div className="footer" />
            </div>
          )}
        </OverviewCard>
      </Col>
    </div>
  )
}

LongestGap.propTypes = {
  bsrCompliance: PropTypes.bool,
  data: PropTypes.array,
  loading: PropTypes.bool,
}

export default LongestGap
